<form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
	<div class="form-group">
		<input
			class="form-input"
			placeholder="First Name"
			formControlName="firstName"
			type="text"
		/>
	</div>
	<div class="form-group">
		<input
			class="form-input"
			placeholder="Last Name"
			formControlName="lastName"
			type="text"
		/>
	</div>
	<div class="form-group">
		<input
			class="form-input"
			placeholder="Username"
			formControlName="username"
			type="text"
		/>
	</div>
	<div class="form-group">
		<input
			class="form-input"
			placeholder="Password"
			formControlName="password"
			type="password"
		/>
	</div>
	<div class="form-group">
		<button class="btn-style">Register</button>
	</div>
</form>
